export const siteName = 'Congreso Veterinario'

export const siteDescription = 'Descripción del sitio'

export const siteURL = 'https://congresoveterinario.cl'

export const apiURL = 'https://trazoevents.com/api'